<script>
import { ref } from 'vue'
import { Modal } from 'bootstrap'

export default {
  name: 'App',
  setup() {
    const isNavbarCollapsed = ref(true)

    const closeNavbar = () => {
      isNavbarCollapsed.value = true
    }

    return {
      isNavbarCollapsed,
      closeNavbar
    }
  }
}
</script>

<template>
  <div class="d-flex flex-column min-vh-100">
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light fixed-top">
      <div class="container-fluid px-4">
        <router-link class="navbar-brand" to="/">
          <img src="@/assets/logo.png" alt="Hammer Naval" height="50">
        </router-link>
        <button 
          class="navbar-toggler border-0" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
          @click="isNavbarCollapsed = !isNavbarCollapsed"
        >
          <i class="bi bi-list fs-4"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav" :class="{ 'show': !isNavbarCollapsed }">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <router-link class="nav-link" to="/" @click="closeNavbar">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/sobre" @click="closeNavbar">Sobre</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/servicos" @click="closeNavbar">Serviços</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/trabalhe-conosco" @click="closeNavbar">Trabalhe Conosco</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="flex-grow-1">
      <router-view></router-view>
    </main>

    <!-- Footer -->
    <footer class="bg-dark text-white pt-5 pb-3">
      <div class="container-fluid px-4 flex-column justify-content-center">
        <div class="row g-12">
          <div class="col-lg-12 d-flex justify-content-center flex-column align-items-center">
            <img src="@/assets/logo-rodape3.png" alt="Hammer Naval" class="mb-4 img-fluid" style="max-height: 60px;">
            <p class="mb-4">
              Excelência em serviços navais, oferecendo soluções completas e inovadoras para o setor marítimo.
            </p>
          </div>
          <div class="col-lg-12 d-flex justify-content-center flex-column align-items-center">
            <h5 class="mb-2">Contato</h5>
            <p class="mb-2"><i class="bi bi-geo-alt me-2"></i>Itajaí, SC</p>
            <!-- <p class="mb-2"><i class="bi bi-telephone me-2"></i>(47) 9999-9999</p> -->
            <p class="mb-0"><i class="bi bi-envelope me-2"></i>contato@hammernaval.com.br</p>
          </div>

          <!-- <div class="col-lg-4">
            <h5 class="mb-4">Links Rápidos</h5>
            <ul class="list-unstyled">
              <li class="mb-2"><router-link to="/" class="text-white text-decoration-none">Home</router-link></li>
              <li class="mb-2"><router-link to="/sobre" class="text-white text-decoration-none">Sobre</router-link></li>
              <li class="mb-2"><router-link to="/servicos" class="text-white text-decoration-none">Serviços</router-link></li>
              <li><router-link to="/trabalhe-conosco" class="text-white text-decoration-none">Trabalhe Conosco</router-link></li>
            </ul>
          </div> -->
        </div>
        <div class="row mt-4">
          <div class="col-12 text-center">
            <p style="font-size: 12px;" class="mb-0">Desenvolvido por <a href="https://simplificamktec.com.br" target="_blank" class="text-white text-decoration-none">Simplifica MK & TEC</a>. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style>
:root {
  --navbar-height: 86px;
  --navbar-height-mobile: 76px;
  --background-color: #F7F7F7;
  --primary-color: #002441;
}

body {
  background-color: var(--background-color);
  margin: 0;
  padding: 0;
  min-height: 100vh;
  padding-top: var(--navbar-height);
}

.navbar {
  height: var(--navbar-height);
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: var(--background-color) !important;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.navbar-collapse {
  background-color: var(--background-color);
}

.navbar-brand {
  padding: 0;
}

.navbar-brand img {
  max-height: 50px;
  width: auto;
  transition: transform 0.3s ease;
}

.navbar-brand:hover img {
  transform: scale(1.05);
}

.nav-link {
  font-weight: 500;
  padding: 0.5rem 1rem !important;
  position: relative;
  color: #333 !important;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.nav-link:hover::after,
.nav-link.router-link-active::after {
  width: 100%;
}

.navbar-toggler {
  border: none;
  padding: 0.5rem;
}

.navbar-toggler:focus {
  box-shadow: none;
}

footer a {
  transition: opacity 0.3s ease;
}

footer a:hover {
  opacity: 0.8;
}

/* Responsividade */
@media (max-width: 991.98px) {
  .navbar {
    height: var(--navbar-height-mobile);
  }

  .navbar-collapse {
    padding: 1rem;
    border-radius: 0.5rem;
    margin-top: 1rem;
  }

  .nav-link {
    padding: 0.75rem 1rem !important;
  }

  .nav-link::after {
    display: none;
  }

  .navbar-brand img {
    max-height: 45px;
  }
}

@media (max-width: 767.98px) {
  .py-6 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .navbar-brand img {
    max-height: 40px;
  }

  footer img {
    max-height: 45px;
  }

  footer {
    text-align: center;
  }

  footer .text-md-start,
  footer .text-md-end {
    text-align: center !important;
  }
}

.bg-dark {
  background-color: var(--primary-color) !important;
}

.btn-primary {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.btn-primary:hover {
  background-color: #003561 !important;
  border-color: #003561 !important;
}

.text-primary {
  color: var(--primary-color) !important;
}
</style>
